import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  Response,
  TQueryParams,
  formatQueryParams,
  parseJsonApiResponse,
  prepareHeaders,
} from 'evolve-ui';

type TAgency = {
  id: string;
  name: string;
  active: 1 | 0;
  acronym: string;
};

export const agenciesApi = createApi({
  reducerPath: 'agencies',
  baseQuery: fetchBaseQuery({
    // ! FIX ME: Change this to agencies api url asap (yet to be implemented)
    baseUrl: `${process.env.GATSBY_COMMUNICATIONS_API_URL}/agencies`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['Agency'],
  endpoints: (builder) => ({
    getAgencies: builder.query<Response<TAgency>, TQueryParams>({
      providesTags: ['Agency'],
      query: formatQueryParams,
      transformResponse: parseJsonApiResponse<TAgency>,
    }),
  }),
});

export const { useGetAgenciesQuery } = agenciesApi;
